export const formatNumberWithSpaces = (
    value: string | number,
    options?: {fixedDecimals?: number}
): string => {
    if (!value && value !== 0) return ''

    const normalizedValue = value.toString().replace(/[\s,]/g, '')
    const numStr =
        options?.fixedDecimals !== undefined && normalizedValue !== '.'
            ? Number(normalizedValue).toFixed(options.fixedDecimals)
            : normalizedValue
    const [integerPart, decimalPart] = numStr.split('.')

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger
}

export const parseFormattedNumber = (value: string): string => {
    if (!value) return ''
    return value.replace(/[\s,]/g, '')
}
